import React from 'react'
import './SectionTitle.sass'

function SectionTitle({ title, theme = null }) {
  return (
    <h5 className={`SectionTitle ${theme ? 'SectionTitle_theme_white' : ''}`}>
      {title}
      <span className="Decorator" />
    </h5>
  )
}

export default SectionTitle
